import { Fragment, useState, useEffect, useContext } from 'react'
import { moneyFormatter } from '../../../../../utils'
import { QuickOrderContext } from '../../../../context/QuickOrderContext'
import { getUniqueIdWithPrefix } from '../../../../../_metronic/assets/ts/_utils'
import { ORDER_LIST_FIXINGS, FIXINGS_CYCLONE_PLATES, FIXINGS_RIVETS, FIXINGS_TEK_SCREWS, FIXINGS_WASHERS, FIXINGS_STEEL_ROOF_SCREWS, FIXINGS_TIMBER_ROOF_SCREWS } from '../../../../common/constant'
import { ConfirmModal } from '../../../../../_metronic/partials/modals/confirm-modal-fixing-item/ConfirmModal'
function NewFixingItem(props: any) {
  const { addToCart, fixingMasterList, colours } = useContext(QuickOrderContext)
  const [fixingOption, setFixingOption] = useState<any[]>([])
  const [showModal, setShowModal] = useState(false)
  const customOrder = [
    FIXINGS_STEEL_ROOF_SCREWS,
    FIXINGS_TIMBER_ROOF_SCREWS,
    FIXINGS_CYCLONE_PLATES,
    FIXINGS_WASHERS
  ];
  //initialize ngOnInit
  useEffect(() => {
    if (fixingMasterList) {
      const availFixing = fixingMasterList.map((x: any) => ({
        id: x.fixingId,
        name: x.fixingName,
      }))
      const distinctFixings: any = Object.values(
        availFixing.reduce((map: any, obj: any) => {
          const key = `${obj.id}-${obj.name}`
          if (!map[key]) map[key] = obj
          return map
        }, {} as Record<string, any>)
      ).map((item: any) => ({
        ...item,
        isSelected: false,
        selectedScrewType: '',
        selectedColorId: 0,
        quantity: 0,
        hasColours: hasColours(item.id),
        hasScrews: hasScrews(item.id)
      })).sort((a: any, b: any) => {
        let indexA = customOrder.indexOf(a.name);
        let indexB = customOrder.indexOf(b.name);
        if (indexA === -1) indexA = 999;
        if (indexB === -1) indexB = 999;
        return indexA - indexB;
      });

      setFixingOption(distinctFixings)
    }
  }, [fixingMasterList])


  const hasColours = (fixingId: number): boolean => {
    const hasAvailableColours = fixingMasterList?.some((x: any) => x.fixingId === fixingId && +x.colourId > 0);
    return !!hasAvailableColours;
  }

  const hasScrews = (fixingId: number): boolean => {
    const hasScrews = fixingMasterList?.some((x: any) => x.screwType !== null && x.fixingId === fixingId)
    return !!hasScrews;
  }

  const updateRow = (id: number, updatedFields: object) => {
    setFixingOption(prev => prev.map(item =>
      item.id === id ? { ...item, ...updatedFields } : item
    ));
  }

  const handleScrewTypeChange = (fixingId: number, value: string) => {
    updateRow(fixingId, { selectedScrewType: value, selectedColorId: 0 });
  };

  const handleColorChange = (fixingId: number, value: string) => {
    updateRow(fixingId, { selectedColorId: +value });
  };

  const handleQuantityChange = (fixingId: number, value: string) => {
    const qty = parseInt(value, 10);
    if (qty >= 0) {
      updateRow(fixingId, { quantity: qty });
    }
  };



  const filterColours = (fixingId: number, screwTypeId?: any) => {
    const availableColourIds = fixingMasterList
      ?.filter((x: any) =>
        x.fixingId === fixingId &&
        (fixingId === 1 || !screwTypeId || x.screwType === screwTypeId) // Special case for Cyclone Plates usually id 1
      )
      .map((x: any) => x.colourId);

    return colours.filter((colour: any) => availableColourIds.includes(colour.id));
  }

  const onAddToCart = () => {

    const selectedItems = fixingOption.filter(f => f.isSelected && f.quantity > 0);

    selectedItems.forEach(item => {
      if (item.hasColours && item.selectedColorId === 0) {
        return;
      }
      if (item.hasScrews && item.selectedScrewType === '') {
        return;
      }

      const pricing = fixingMasterList.find((f: any) =>
        f.fixingId === item.id &&
        (item.name === FIXINGS_CYCLONE_PLATES || f.screwType === item.selectedScrewType) &&
        (f.colourId === item.selectedColorId || !item.selectedColorId)
      );

      const colorObj = colours.find((c: any) => c.id === item.selectedColorId);


      addToCart({
        ...pricing,
        price: pricing?.priceLevel1 || 0,
        unitPrice: pricing?.priceLevel1 || 0,
        pricingId: pricing?.id,
        quantity: item.quantity,
        customId: Math.random(),
        type: 'fixing',
        uniqueID: `fixing-${item.id}-${item.selectedScrewType}-${getUniqueIdWithPrefix('fixing')}`.replace(/\s/g, ''),
        productType: ORDER_LIST_FIXINGS,
        productName: item.name,
        description: `${item.selectedScrewType ? item.selectedScrewType + ',' : ''} ${colorObj ? colorObj.name : '-'}`,
        colorName: colorObj ? colorObj.name : '-'
      });
    });
    const resetOptions = fixingOption.map((item) => ({
      ...item,
      selectedScrewType: '',
      selectedColorId: 0,
      quantity: 0
    }));
    setFixingOption(resetOptions);
  };

  const getRowPrice = (fixing: any) => {
    if (!fixing.isSelected) return 0;

    // Find the record that matches this row's current state
    const pricingRecord = fixingMasterList?.find((f: any) =>
      f.fixingId === fixing.id &&
      (fixing.name === FIXINGS_CYCLONE_PLATES || f.screwType === fixing.selectedScrewType) &&
      (f.colourId === fixing.selectedColorId || !fixing.selectedColorId)
    );
    return pricingRecord?.priceLevel1 || 0;
  };

  const handleAddClick = () => {
    const selectedItems = fixingOption.filter(f => f.isSelected && f.quantity > 0);

    if (selectedItems.length === 0) {
      //alert("Please select an item and quantity first.");
      return;
    }

    // Check if they selected a Roof Screw
    const hasRoofScrews = selectedItems.some(f =>
      f.name === FIXINGS_STEEL_ROOF_SCREWS || f.name === FIXINGS_TIMBER_ROOF_SCREWS
    );

    const extrasAlreadySelected = selectedItems.some(f =>
      f.name === FIXINGS_CYCLONE_PLATES || f.name === FIXINGS_WASHERS
    );
    if (hasRoofScrews && !extrasAlreadySelected) {
      setShowModal(true); // Ask if they want to pre-select extras
    } else {
      onAddToCart();
    }
  };

  const handleConfirm = (addExtras: boolean) => {
    if (addExtras) {
      const roofScrew = fixingOption.find(f =>
        (f.name === FIXINGS_STEEL_ROOF_SCREWS || f.name === FIXINGS_TIMBER_ROOF_SCREWS) && f.isSelected
      );
      const screwQty = roofScrew?.quantity || 0;

      setFixingOption(prev => prev.map(item => {
        const isExtra = item.name === FIXINGS_CYCLONE_PLATES || item.name === FIXINGS_WASHERS;
        if (isExtra) {
          return { ...item, isSelected: true, quantity: screwQty };
        }
        return item;
      }));
      setShowModal(false);
    } else {
      onAddToCart();
      setShowModal(false);
    }
  };

  const isAddDisabled = (): boolean => {
    let isDisabled = true;
    const fixingOptions = fixingOption.filter(f => f.isSelected);
    if (fixingOptions.length == 0) {
      return isDisabled;
    }

    for (let i = 0, len = fixingOptions.length; i < len; i++) {
      if (fixingOptions[i].quantity === 0) {
        return true;
      }
      else if (fixingOptions[i].hasColours && fixingOptions[i].selectedColorId === 0) {
        return true;
      }
      else if (fixingOptions[i].hasScrews && fixingOptions[i].selectedScrewType === '') {
        return true;
      }
    }
    return false;
  };

  return (
    <Fragment>
      <ConfirmModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
        items={fixingOption.filter(f => f.isSelected && f.quantity > 0)}
      />
      <div className='row mb-5'>
        <div className='col-md-9' />
        <div className='col-md-3 text-end'>
          <button
            disabled={isAddDisabled()}
            className='btn btn-primary w-100' onClick={handleAddClick}>
            <i className='fa fa-plus'></i> ADD
          </button>
        </div>
      </div>

      {fixingOption.map((fixing) => {
        const screwTypeOptions = fixingMasterList
          ?.filter((x: any) => x.screwType !== null && x.fixingId === fixing.id)
          .map((x: any) => ({ id: x.screwType, name: x.screwType }))
          .filter((v: any, i: number, arr: any[]) => arr.findIndex((t) => t.id === v.id) === i);

        return (
          <div key={fixing.id} className='row mt-4 d-flex align-items-center pb-3'>
            {/* Checkbox */}
            <div className="col-md-2 pt-4">
              <input
                id={`fixing-${fixing.id}`}
                className="form-check-input me-2"
                type="checkbox"
                checked={fixing.isSelected}
                onChange={(e) => updateRow(fixing.id, { isSelected: e.target.checked })}
              />
              <label htmlFor={`fixing-${fixing.id}`} className="fw-bolder text-dark mb-0">
                {fixing.name}
              </label>
            </div>
            {<div className="col-md-1  fw- text-end pt-4">
              <span className="fw-bold text-dark">
                {
                  moneyFormatter.format(getRowPrice(fixing))
                }
              </span>
            </div>}

            {/* Screw Type */}
            <div className="col-md-3">
              {fixing.name !== FIXINGS_CYCLONE_PLATES && (
                <>
                  <label className="fw-bolder">Screw Type</label>
                  <select
                    className="form-select"
                    disabled={!fixing.isSelected}
                    value={fixing.selectedScrewType || ""}
                    onChange={(e) => handleScrewTypeChange(fixing.id, e.target.value)}
                  >
                    <option value="">Select One</option>
                    {screwTypeOptions.map((item: any) => (
                      <option key={item.id} value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </>
              )}
            </div>

            {/* Quantity */}
            <div className="col-md-2">
              <label className="fw-bolder">Quantity</label>
              <input
                type="number"
                className="form-control"
                disabled={!fixing.isSelected}
                value={fixing.quantity || ""}
                onChange={(e) => handleQuantityChange(fixing.id, e.target.value)}
                min="0"
              />
            </div>

            {/* Colour */}
            <div className="col-md-3">
              {[FIXINGS_CYCLONE_PLATES, FIXINGS_RIVETS, FIXINGS_TEK_SCREWS].includes(fixing.name) && (
                <>
                  <label className="fw-bolder">Colour</label>
                  <select
                    className="form-select"
                    disabled={!fixing.isSelected}
                    value={fixing.selectedColorId || ""}
                    onChange={(e) => handleColorChange(fixing.id, e.target.value)}
                  >
                    <option value="">Select One</option>
                    {filterColours(fixing.id, fixing.selectedScrewType).map((item: any) => (
                      <option value={item.id} key={item.id}>{item.name}</option>
                    ))}
                  </select>
                </>
              )}
            </div>
            {/* <div className="col-md-2 text-end pt-4">
              <span className="fw-bold text-primary">
                {moneyFormatter.format(0)}
              </span>
            </div> */}

          </div>
        );
      })}
    </Fragment>
  )
}

export default NewFixingItem